import { render, staticRenderFns } from "./WithdrawalSameName.vue?vue&type=template&id=ff311c98"
import script from "./WithdrawalSameName.vue?vue&type=script&lang=js"
export * from "./WithdrawalSameName.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalSameName.vue?vue&type=style&index=0&id=ff311c98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports